import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { Redirect, Link } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { inHomeVerifyErrors } from "../../constants/textConstants"
import AppointmentOverview from './AppointmentOverview';
import SchedulingQuestions from './SchedulingQuestions';
import InHomeSchedulingButtons from './InHomeSchedulingButtons';
import Spinner from '../common/spinner';
import InfoModal from '../common/InfoModal';
import StickyProgressBar from '../common/StickyProgressBar';


const InHomeConfirmDetails = ({ history, apptTime, bookAppointment, bookApptPending, bookApptResult }) => {

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeConfirmDetails.Displayed`, new Date(), Tools.getURLPath());

    }, []);

    useEffect(() => {

        if (bookApptResult?.success) {
            history.push({ pathname: "/inhomeschedule/s8", state: { isBookingSuccess: true } })
        }
        else if (bookApptResult && bookApptResult?.errorMsg === inHomeVerifyErrors.TimeAlreadyBooked) {
            setShowModal(true);
        }
        else if (bookApptResult && bookApptResult?.errorMsg) {
            history.push({ pathname: "/inhomeschedule/s8", state: { isBookingSuccess: false } })
        }
    }, [bookApptResult])

    const [showModal, setShowModal] = useState(false);

    const onClickPrevious = () => {
        logUI(`MBHWeb.UI.InHomeConfirmDetails.Previous.Clicked`, new Date(), Tools.getURLPath());
        history.push("/inhomeschedule/s6")
    }

    const onClickBook = () => {
        logUI(`MBHWeb.UI.InHomeConfirmDetails.Book.Clicked`, new Date(), Tools.getURLPath());
        bookAppointment();
    }

    const closeModal = () => {
        setShowModal(false);
        history.push("/inhomeschedule/s6")
    }

    return (
        <>{!apptTime ? <Redirect to='/inhomeschedule/s8' /> :
            <>
                <StickyProgressBar className="inhome"/>
                <div className="container-fluid body-content inhome inhome-scheduling inhome-scheduling-container inhome-confirm-page">
                    <div className="row">
                        <div className="col-12">
                            <div className="row flex">
                                <div className="in-home-left-panel scheduling-wrapper">
                                    <div className="detail-wrapper confirm-detail-wrapper">
                                        <div className="verify-wrapper-content">
                                            <h1 className="page-heading">Does this look correct?</h1>
                                            <p className="subheading-info"> Review your appointment overview <span className="show-desktop-only">to the right </span>and make sure it's correct before hitting <span className="highlight">BOOK IT</span> to schedule your appointment.</p>
                                            {bookApptPending && <Spinner />}
                                            <div className="confirm-aapointment-overview">
                                                <AppointmentOverview confirmPhase={true} />
                                            </div>
                                            <div className="confirm-button-wraper-desktop">
                                                <InHomeSchedulingButtons leftOnClick={onClickPrevious} rightBtnLabel='BOOK IT' rightOnClick={onClickBook} />
                                            </div>
                                        </div>

                                        <div className="verify-wrapper-img-sec">
                                            <img src='/images/group-2.svg' alt="logo" />
                                        </div>
                                        <div className="confirm-button-wraper-device">
                                            <InHomeSchedulingButtons leftOnClick={onClickPrevious} rightBtnLabel='BOOK IT' rightOnClick={onClickBook} />
                                        </div>

                                    </div>
                                    <SchedulingQuestions />
                                </div>
                                <div className="in-home-right-panel">
                                    <AppointmentOverview confirmPhase={true} />
                                </div>
                                <InfoModal
                                    alignText="center"
                                    hideBorder
                                    className="appt-booking-modal"
                                    isOpen={showModal}
                                    showModalHeader
                                    toggle={() => { setShowModal(false) }}
                                    modalBody={
                                        <div className="content">
                                            <span className="title">The time you selected is no longer available.</span>
                                            <span className="subtitle">Please select a new time to continue booking.</span>
                                        </div>
                                    }
                                    modalFooter={
                                        <div>
                                            <div><button className="btn btn-primary primary-action" onClick={closeModal}>Select New Time</button></div>
                                            <div className="btn-cancel"><Link to="/" replace>CANCEL BOOKING</Link></div>
                                        </div>
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        }
        </>
    );
}
const mapStateToProps = state => {

    return {
        apptTime: state.inHome.selectedDateTime,
        bookApptPending: state.inHome.bookApptPending,
        bookApptResult: state.inHome.bookApptResult
    }
}

const mapDispatchToProps = dispatch => {
    return {
        bookAppointment: () => {
            dispatch({ type: types.BOOK_INHOME_APPT })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeConfirmDetails);